import cx from 'classnames';
import React, { type ReactNode } from 'react';

import { FileViewerToolbar } from '../FileViewerToolbar/FileViewerToolbar';

type Props = {
  className?: string;
  leftActions?: ReactNode[];
  rightActions?: ReactNode[];
};

export const ViewerLoader = ({
  className = '',
  leftActions = [],
  rightActions = [],
}: Props) => {
  return (
    <div
      className={cx(
        'bg-background-primary-default flex h-full flex-[1_0_24rem] flex-col overflow-hidden',
        className,
      )}
    >
      <FileViewerToolbar
        leftActions={leftActions}
        rightActions={rightActions}
      />
      <div className="rounded-8 border-border-default grow border-[1px] border-solid" />
    </div>
  );
};
